import React from 'react';
import '../../containers/SMSRequest/CarouselAssets/CarouselAssets.scss';
import icon from '@core/assets/images/sms-feature-ablaufgrafik-desktop-step3-rgb.svg';
import { ReactSVG } from 'react-svg';

function Icon({ afterInjection }) {
    return afterInjection ? <ReactSVG src={icon} afterInjection={afterInjection} /> : <ReactSVG src={icon} />;
}

export default Icon;
